<script>
  export let roles
  export let getRoleLabel
  export let getUser

  import { createEventDispatcher } from 'svelte'

  import UserShort from './UserShort.svelte'

  const dispatch = createEventDispatcher()

  let value = ''
  let user
  let loading
  let valid = false

  function reset() {
    value = ''
    user = undefined
    loading = false
    valid = false
  }
  reset()

  async function valueTyped() {
    console.log('Value Typed', value)
    if (value.length > 3 && value.includes('@') && value.includes('.')) {
      loading = true
      valid = true

      user = await getUser(value)
      console.log('User is', user)

      loading = false
    } else {
      valid = false
    }
  }

  async function addSharing(role) {
    console.log('Choose user', user)
    console.log('Role', role)

    dispatch('chooseUser', {
      user: user,
      role: role,
    })

    reset()
  }
</script>

<div class="d-flex flex-column" style="width: 100%;">
  <div class="form-floating mb-3">
    <input
      type="email"
      class="form-control"
      id="floatingInput"
      placeholder="Add User via Email address"
      bind:value
      on:input={valueTyped}
    />
    <label for="floatingInput">Add User via Email address</label>
  </div>

  {#if loading || user || valid}
    <div>
      {#if loading}
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      {:else if user}
        <div class="d-flex justify-content-between align-items-center">
          <div class="me-auto">
            <UserShort {user} />
          </div>
          <div class="dropdown">
            <button
              class="btn btn-primary dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Choose Role
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              {#each roles as role}
                <li>
                  <button
                    class="dropdown-item"
                    on:click={() => addSharing(role)}
                    >{getRoleLabel(role)}</button
                  >
                </li>
              {/each}
            </ul>
          </div>
        </div>
      {:else if valid}
        <i>No Fich user for email address {value}</i>
      {/if}
    </div>
  {/if}
</div>
